import React, { useState, useEffect } from "react";
import LoginForm from "../components/LoginForm";
import InitialModalRedemption from "../components/InitialModalRedemption";
import ValidatedModalRedemption from "../components/ValidatedModalRedemption";
import { baseUrl } from "../baseUrl";
import axios from "axios";
const QrcodeRedemption = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const guid = window.location.pathname.split("/").pop();

  // Dummy user data simulation
  useEffect(() => {
    const dummyData = {
        reference: guid,
        firstName: "Emmanuel",
        lastName: "Bright",
        collected: false,
        items: [
          { product: "Pepsi", size: "50cl", quantity: "1 Case" },
          { product: "Mirinda", size: "60cl", quantity: "2 Packs" },
          { product: "7Up", size: "50cl", quantity: "1 Case" },
        ],
      };
      
    setData(dummyData);
    setLoading(false);
  }, [guid]);

  const handleLogin = async (username, password) => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}Auth/Login`, {
        username,
        password,
      });
      
      if (response.status === 200) {
        const token = response.data;
        localStorage.setItem("token", token);
  
        const expiryTime = new Date().getTime() + 12 * 60 * 60 * 1000;
        localStorage.setItem("expiryTime", expiryTime);
        localStorage.setItem("isLoggedIn", true);
        setIsLoggedIn(true);
        setShowLogin(false);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCLoseLogin = () => {
    setShowLogin(false);
  };
  const onSubmit = (data) => {
    handleLogin(data.username, data.password);
    handleCLoseLogin();
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  const markAsCollected = () => {
    // Update dummy data to simulate "Mark as Collected"
    setData(prev => ({ ...prev, collected: true }));
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="w-full h-screen flex justify-center items-center qr-container2 relative ">
     <div className="h-[90vh] w-4/5 mx-auto flex flex-col gap-4 relative p-2 qr-bg">
        {!isLoggedIn ? (
          <InitialModalRedemption data={data} handleShowLogin={() => setShowLogin(true)} />
        ) : (
          <ValidatedModalRedemption 
            data={data} 
            handleLogout={handleLogout} 
            markAsCollected={markAsCollected}
          />
        )}
      </div>

      {showLogin && (
        <LoginForm 
          handleClose={() => setShowLogin(false)} 
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default QrcodeRedemption;
